<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
            <span class="px-3">{{ $t('View Staff Member Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-flex xs12 class="headline no-select not-printable pb-1">
            <v-layout justify-space-between>
              <v-chip label :color="staffMemberInfo.user_status === 'Active' ? 'success' : 'error'" text-color="white">
                <v-icon left>
                  {{ staffMemberInfo.user_status === 'Active' ? 'check_circle' : 'block' }}
                </v-icon>
                {{ staffMemberInfo.user_status === 'Active' ? $t('Active') : $t('Inactive') }}
              </v-chip>
            </v-layout>
          </v-flex>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Staff') }}</strong>
            </v-flex>
            <v-flex xs12 sm3>
              <v-layout column style="margin:0 auto; max-width:200px; max-height:280px">
                <v-flex xs12>
                  <v-chip
                    label
                    class="only-for-print ma-0"
                    :color="staffMemberInfo.user_status === 'Active' ? 'success lighten-2' : 'error lighten-2'"
                    style="color:white !important"
                  >
                    {{ staffMemberInfo.user_status === 'Active' ? $t('Active') : $t('Inactive') }}
                  </v-chip>
                </v-flex>
                <a v-if="staffMemberInfo.user_image_path" @click="dialogs.imageViewerDialog = true">
                  <v-img :src="`${baseUrls.images}/${staffMemberInfo.user_image_path}`" height="210" />
                </a>
                <v-img
                  v-show="!staffMemberInfo.user_image_path && staffMemberInfo.user_gender === 'Male'"
                  :src="`${baseUrls.images}/profile-male.png`"
                  height="210"
                />
                <v-img
                  v-show="!staffMemberInfo.user_image_path && staffMemberInfo.user_gender === 'Female'"
                  :src="`${baseUrls.images}/profile-female.png`"
                  height="210"
                />
              </v-layout>
            </v-flex>

            <v-flex xs12 sm9 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <v-flex xs12></v-flex>
                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Full Name') }}</div>
                  <strong>{{ staffMemberInfo.user_full_name || '-' }}</strong>
                </v-flex>

                <v-flex xs12 class="pb-3">
                  <div class="caption no-select">{{ $t('Email') }}</div>
                  <strong>{{ staffMemberInfo.email || '-' }}</strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">{{ $t('Phone') }}</div>
                  <strong>
                    <span dir="ltr">{{ staffMemberInfo.user_phone || '-' }}</span>
                  </strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">{{ $t('Gender') }}</div>
                  <strong>{{ $t(staffMemberInfo.user_gender) || '-' }}</strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">{{ $t('Birth Date') }}</div>
                  <strong v-if="staffMemberInfo.user_dob">
                    {{ staffMemberInfo.user_dob }}
                  </strong>
                  <strong v-else>-</strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">{{ $t('Blood Group') }}</div>
                  <strong>
                    <span dir="ltr">{{ $t(staffMemberInfo.user_blood_group) || '-' }}</span>
                  </strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Marital Status') }}
                  </div>
                  <strong>{{ $t(staffMemberInfo.user_marital_status) || '-' }}</strong>
                </v-flex>

                <v-flex xs6 sm4 class="pb-3">
                  <div class="caption no-select">{{ $t('Nationality') }}</div>
                  <strong>{{ staffMemberInfo.user_nationality || '-' }}</strong>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex
              xs12
              :class="{
                'pt-0': $vuetify.breakpoint.xsOnly,
                'pt-3': !$vuetify.breakpoint.xsOnly
              }"
            >
              <div class="caption no-select">{{ $t('Address') }}</div>
              <strong v-html="lnToBr(staffMemberInfo.user_address) || '-'" />
            </v-flex>
            <v-flex xs6 sm3 class="pt-3">
              <div class="caption no-select">{{ $t('Joining Date') }}</div>
              <strong v-if="staffMemberInfo.user_joining_date">
                {{ staffMemberInfo.user_joining_date }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3">
              <div class="caption no-select">{{ $t('Job Title') }}</div>
              <strong>{{ staffMemberInfo.user_job_title || '-' }}</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3">
              <div class="caption no-select">{{ $t('Base Salary') }}</div>
              <strong v-if="staffMemberInfo.base_salary">
                {{ staffMemberInfo.base_salary | currency }}
              </strong>
              <strong v-else>-</strong>
            </v-flex>

            <v-flex xs6 sm3 class="pt-3">
              <div class="caption no-select">{{ $t('Outlet') }}</div>
              <strong>{{ staffMemberInfo.outlet_name || '-' }}</strong>
            </v-flex>

            <v-flex xs12 pt-3 v-if="staffMemberInfo.sub_outlet_id_fk !== null">
              <div class="caption no-select">{{ $t('Sub Outlet') }}</div>
              <strong v-for="(s, index) in staffMemberInfo.sub_outlet_detail" :key="index">
                {{ s.outlet_name }}
                <span v-if="index !== staffMemberInfo.sub_outlet_detail.length - 1">,&nbsp; </span>
              </strong>
            </v-flex>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>

    <image-viewer
      :imageSrc="staffMemberInfo.user_image_path"
      :maxWidth="600"
      :imageViewerDialog="dialogs.imageViewerDialog"
      @hidemodal="dialogs.imageViewerDialog = false"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    imageViewer: () => import('@/views/_partials/AppImageViewer.vue'),
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dialogs: {
        imageViewerDialog: false
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      staffMemberInfo: 'staff/getStaffMemberInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
